module.exports = __webpack_public_path__ + "media/images/emoticons/sagittarius-b89189f62d4115c887c292b4a93defe6.gif";